export default {
    requiredClient: 'Please select a client',
    requiredOrder: 'Please select an order',
    requiredDate: 'Please choose a date',
    requiredTime: 'Please choose a time',
    requiredCalendar: 'Please choose a calendar type',
}
